import { applyUpdate } from 'yjs';
/** Origin of Yjs transactions that load a state saved in the note (not made by the local user) */
export const RemoteCollaborationOrigin = 'remote-note-state';
class LocalAwareness {
    constructor(doc) {
        this.doc = doc;
        this.localState = null;
        this.listeners = new Set();
    }
    getLocalState() {
        return this.localState;
    }
    getStates() {
        /** Keyed by the document client id, so the local user is not rendered as a remote cursor */
        return new Map(this.localState ? [[this.doc.clientID, this.localState]] : []);
    }
    setLocalState(state) {
        this.localState = state;
        this.listeners.forEach((listener) => listener());
    }
    setLocalStateField(field, value) {
        if (this.localState) {
            this.setLocalState({ ...this.localState, [field]: value });
        }
    }
    on(_type, callback) {
        this.listeners.add(callback);
    }
    off(_type, callback) {
        this.listeners.delete(callback);
    }
}
/**
 * Yjs provider without network: the document is loaded from (and saved to) the note itself,
 * and states arriving with synced notes are applied with `applyState`.
 */
export class LocalCollaborationProvider {
    constructor(doc, initialState) {
        this.doc = doc;
        this.initialState = initialState;
        this.listeners = new Map();
        this.awareness = new LocalAwareness(doc);
    }
    connect() {
        if (this.initialState) {
            this.applyState(this.initialState);
            this.initialState = undefined;
        }
        this.emit('status', { status: 'connected' });
        this.emit('sync', true);
    }
    disconnect() {
        this.emit('status', { status: 'disconnected' });
    }
    destroy() {
        this.disconnect();
    }
    /** Applying a state that is already contained in the document is a no-op */
    applyState(state) {
        applyUpdate(this.doc, state, RemoteCollaborationOrigin);
    }
    on(type, callback) {
        var _a;
        if (!this.listeners.has(type)) {
            this.listeners.set(type, new Set());
        }
        (_a = this.listeners.get(type)) === null || _a === void 0 ? void 0 : _a.add(callback);
    }
    off(type, callback) {
        var _a;
        (_a = this.listeners.get(type)) === null || _a === void 0 ? void 0 : _a.delete(callback);
    }
    emit(type, arg) {
        var _a;
        (_a = this.listeners.get(type)) === null || _a === void 0 ? void 0 : _a.forEach((listener) => listener(arg));
    }
}
